import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useContext } from "react";
import { Button } from "react-bootstrap";
import { AuthContext } from "../context/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";

const ETradeAuthorization = ({ open, onClose, currentIntegration  }) => {
    const {etradeAuthData} = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    
    const handleAuthClick = async (event) => {
        const redirectUrl = etradeAuthData.auth_url;
        if(currentIntegration === 'E*Trade'){
            window.open(redirectUrl, '_blank');
        }else if(currentIntegration === 'Coinbase'){
            window.location.href = redirectUrl;
        }
    }

    const handleClickHere = async (event) => {
        if(currentIntegration === 'E*Trade'){
            navigate('/VerifyTrade');
        }else if(currentIntegration === 'Coinbase'){
            navigate('/VerifyCoin');
        }
    }
    
    return(
        <Dialog open={open} 
            onClose={currentIntegration === "Coinbase" 
            ? (event, reason) => {
                if (reason !== "backdropClick") {
                  onClose();
                }
              } 
            : onClose}
          
        aria-labelledby="settings-dialog-title" fullWidth PaperProps={{
            style: {
              width: '550px',
              maxWidth: '100%',
            },
        }} className="setting-dialog">
            <DialogTitle id="settings-dialog-title" className="d-flex justify-content-between mb-4">
                <div className="d-flex align-items-center">
                    <span style={{marginLeft:"10px"}}>{currentIntegration} Authentication</span>
                </div>
                {currentIntegration !== "Coinbase" && (
                    <img
                        style={{ height: "22px", width: "20px", cursor: "pointer" }}
                        src={`${process.env.PUBLIC_URL}/images/close.png`}
                        alt="close"
                        onClick={onClose}
                    />
                )}
            </DialogTitle>
            <DialogContent>
                <span style={{fontSize: "16px"}}>Please authenticate {currentIntegration} by clicking on below authenticate button</span>
                <div className="mt-1 mb-3 row justify-content-center">
                    <Button variant="primary" type="submit" onClick={handleAuthClick} style={{backgroundColor: '#317CFF', textTransform: 'none'}} className="mt-3 w-55 p-2 theme-btn-email">
                        {'Authenticate'}
                    </Button>
                </div>
                {(currentIntegration !== "Coinbase" || location.pathname === '/VerifyTrade') && (
                    <>
                        <div className='mt-5'>
                            <span style={{fontSize: "16px"}}>After authentication click on below button to enter the code</span>
                        </div>
                        <div className="mt-1 mb-3 row justify-content-center">
                            <Button variant="primary" type="submit" onClick={handleClickHere} style={{backgroundColor: '#317CFF', textTransform: 'none'}} className="mt-3 w-55 p-2 theme-btn-email">
                                {'Click here'}
                            </Button>
                        </div>
                    </>
                )}

                
            </DialogContent>
        </Dialog>
    );
};

export default ETradeAuthorization;